export default __webpack_public_path__ + "static/media/4-3.bee2f2b1.jpg";